export default __webpack_public_path__ + "static/media/object--water-valve.848a98d0.png";